import { useState } from "react";
import "./OpenRoles.css";
import JobApplicationModal from "../../../components/JobApplicationModal/JobApplicationModal"

const categories = [
  "All",
  "Engineering",
  "Design",
  "Marketing",
  "Sales",
];

const jobs = [
  {
    title: "Senior Full-Stack Engineer",
    category: "Engineering",
    location: "On-site",
    type: "Full-time",
  },
  {
    title: "Frontend Engineer ",
    category: "Engineering",
    location: "On-site",
    type: "Full-time",
  },
  {
    title: "Lead Brand Designer",
    category: "Design",
    location: "On-site",
    type: "Full-time",
  },
  {
    title: "Senior Product Marketing Manager",
    category: "Marketing",
    location: "On-site",
    type: "Full-time",
  },
  {
    title: "Content & Creator Relations Specialist",
    category: "Marketing",
    location: "On-site",
    type: "Full-time",
  },
  {
    title: "Enterprise Account Executive",
    category: "Sales",
    location: "On-site",
    type: "Full-time",
  },
];

const OpenRoles = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [isJobModalOpen, setIsJobModalOpen] = useState(false);

  const filteredJobs =
    activeCategory === "All"
      ? jobs
      : jobs.filter((job) => job.category === activeCategory);

  return (
    <section id="open-roles" className="open-roles">
      {/* Header */}
      <div className="open-roles__header">
        <span className="open-roles__eyebrow">
          OPEN ROLES
        </span>

        <h2>Find your next challenge</h2>

        {/* Filters */}
        <div className="open-roles__filters">
          {categories.map((category) => (
            <button
              key={category}
              type="button"
              className={
                activeCategory === category
                  ? "open-roles__filter open-roles__filter--active"
                  : "open-roles__filter"
              }
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      {/* Jobs */}
      <div className="open-roles__list">
        {filteredJobs.map((job) => (
          <div className="open-roles__job" key={job.title}>
            <div className="open-roles__job-info">
              <h3>{job.title}</h3>

              <div className="open-roles__meta">
                <span>{job.category}</span>
                <span>•</span>
                <span>{job.location}</span>
                <span>•</span>
                <span>{job.type}</span>
              </div>
            </div>

            <button onClick={() => setIsJobModalOpen(true)} className="open-roles__apply">
  Apply Now
</button>
     </div>
        ))}
      </div>

      <JobApplicationModal
  isOpen={isJobModalOpen}
  onClose={() => setIsJobModalOpen(false)}
/>
    </section>
  );
};

export default OpenRoles;